import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { CurationStatusValue } from '../../interfaces/curation-status';
import { IAberrations } from '../../interfaces/aberrations.interface';
import { ManualCurationService } from '../../services/manual-curation.service';
import { RouterManagerService } from "@ispm/core/services/router-manager.service";

@Component({
  selector: 'gen-curation-action',
  templateUrl: './curation-action.component.html',
  styleUrls: ['./curation-action.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CurationActionComponent {
  @Input('columnValue')
  aberration: IAberrations;

  constructor(private manualCuration: ManualCurationService, private routerManagerService: RouterManagerService, private cd: ChangeDetectorRef) { }

  curationRequest(event) {
    const command = this.wasCuratedBefore ? 'update' : 'curate';
    this.manualCuration.addToManualCuration(this.routerManagerService.parameters?.testId, this.routerManagerService.parameters?.revisionId, command, this.aberration.id)
      .subscribe(statuses => {
        this.aberration.manualCurationStatus = statuses[this.aberration.id];
        this.cd.markForCheck();
      });
    event.stopPropagation();
  }

  get curationInProgress(): boolean {
    return this.aberration.manualCurationStatus && this.aberration.manualCurationStatus.hasCurationInProgress;
  }

  get wasCuratedBefore(): boolean {
    return this.aberration.manualCurationStatus && this.aberration.manualCurationStatus.value === CurationStatusValue.Curated;
  }
}
